module.exports = __webpack_public_path__ + "static/media/serviceIndustry5.c8cc76c0.png";